// generated from 12_117 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasUninstalledFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_uninstalled_filter"),
  comparison_key: z.enum([
    "12", // 11_713 (96.67%)
    "11", // 404 (3.33%)
  ]),
  display_name: z.string(),
  // undefined: 9_233 (76.20%), defined 2_884 (23.80%)
  raw_value: z.null().optional(),
  value: z.null(),
  varies_by_app_group: z.literal(false),
});
